import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MessengerOutlineIcon(props: IconProps) {
    return <Icon {...props} iconKey={"messenger_outline"}/>
}
